import React from 'react';
import styles from './ToolbarButton.module.css';

type ToolbarButtonProps = {
  children: React.ReactNode,
  active?: boolean,
  onClick?: () => void,
};

export default function ToolbarButton({
  children,
  active,
  onClick,
}: ToolbarButtonProps) {
  return (
    <button
      className={`${styles.toolbarButton} ${
        active ? styles.toolbarButtonActive : ''
      }`}
      onClick={onClick}
    >
      <div className={styles.toolbarButtonLabel}>{children}</div>
    </button>
  );
}
